import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkDirective from "remark-directive";
// eslint-disable-next-line import/no-unresolved
import remarkDirectiveRehype from "remark-directive-rehype";
import styled from "styled-components";

import Accordion from "../components/Accordion/Accordion";
import MarkdownLink from "../components/MarkdownLink/MarkdownLink";

const StyledReactMarkdown = styled(ReactMarkdown)`
  a {
    color: ${({ theme }) => `${theme.primaryColor}`};
  }
`;

function Markdown(props) {
  const { children, className, ...rest } = props;

  return (
    <StyledReactMarkdown
      className={className}
      components={{
        accordion: Accordion,
        navlink: MarkdownLink,
      }}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkDirective, remarkDirectiveRehype]}
      {...rest}
    >
      {children}
    </StyledReactMarkdown>
  );
}

export default observer(Markdown);

Markdown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Markdown.defaultProps = {
  children: null,
  className: null,
};
